// extracted by mini-css-extract-plugin
module.exports = {"container":"ImagePlaceHolder_container__Obsnm","heading":"ImagePlaceHolder_heading__1RB0r","hidden":"ImagePlaceHolder_hidden__3NPPJ","image":"ImagePlaceHolder_image__1b1RM"};